module.exports = __webpack_public_path__ + "media/audio4.a7a61b9d.mp4";